import { InjectionToken } from '@angular/core';
import { ISettingOpener } from './interfaces/setting-opener';

export const SETTING_OPENER_TOKEN = new InjectionToken<ISettingOpener>('SettingOpener');
